import TuleButton from "../../../../../../common/components/atom/TuleButton.tsx/TuleButton";
import BorneSRC from "../../../../../../assets/borne-medium.png";
import useQueryURL from "../../../../../../common/hooks/useQueryURL";
import NewStationModal from "../../NewStationModal/NewStationModal";
import useNavigationApp from "../../../../../../navigation/useNavigationApp";
import { useAuth } from "../../../../../auth/hooks";
import { userRoles } from "../../../../../user/types/user.types";
export default function AddNewStationBtn({
  modalId = "modal_add_station",
  organizationId,
  goToCreateNewStationMode,
}: {
  modalId?: string;
  organizationId?: string;
  goToCreateNewStationMode?: boolean;
}) {
  const { setQueryValue } = useQueryURL();
  const navigateApp = useNavigationApp();
  const { userRole } = useAuth();
  if (!userRole || userRole < userRoles.ADMIN) {
    return <></>;
  }
  const onClick = () => {
    if (goToCreateNewStationMode) {
      navigateApp.goToCreateNewStation();
      return;
    }
    setQueryValue({ [modalId]: "true" });
  };
  return (
    <TuleButton
      label="Ajouter une Nouvelle Station"
      onClick={onClick}
      color={{
        text: "white",
        background: "#042536",
        border: "#3684A650",
      }}
      ImageRender={() => <BorneImage />}
    />
  );
}

const BorneImage = () => {
  return (
    <img
      style={{
        width: "100%",
        height: "100%",
        marginTop: "110%",
        marginLeft: "35%",
        scale: "2",
        objectFit: "contain",
      }}
      src={BorneSRC}
      alt="Borne"
    />
  );
};

export const ModalBtnNewStation = ({
  modalId,
  organizationId,
}: {
  modalId?: string;
  organizationId?: string;
}) => {
  const modaleId = modalId || "modal_add_station";
  return (
    <>
      <AddNewStationBtn modalId={modalId} />
      <NewStationModal modalId={modaleId} organizationId={organizationId} />
    </>
  );
};
